export default {
    global: 'Global',
    my_school: 'My School',
}
